// extracted by mini-css-extract-plugin
module.exports = {"container":"_223UcGDSa6GGkcFyg3uPeL","groupsList":"_1CLU5ZA4tA5xV3A9xaZfU8"};